import { useTranslation } from 'react-i18next';
import { LOCALES, type Locale } from '@yp/shared';

/**
 * Language switch. Persisted per user by i18n.ts's localStorage detector.
 *
 * Each language is labelled in its OWN script - a host looking for Arabic scans
 * for "العربية", not for "Arabic".
 */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const active = i18n.resolvedLanguage as Locale;

  return (
    <div
      className="flex items-center gap-1 rounded-full border border-slate-200 p-1"
      role="group"
      aria-label={t('app.language')}
    >
      {LOCALES.map((locale) => (
        <button
          key={locale}
          type="button"
          onClick={() => void i18n.changeLanguage(locale)}
          aria-pressed={active === locale}
          className={[
            'rounded-full px-3 py-1 text-sm font-medium transition-colors',
            active === locale
              ? 'bg-brand-teal text-white'
              : 'text-slate-600 hover:bg-brand-teal-light',
          ].join(' ')}
        >
          {locale === 'ar' ? t('app.languageArabic') : t('app.languageEnglish')}
        </button>
      ))}
    </div>
  );
}
